module.exports = __webpack_public_path__ + "images/img-28.6d376785.jpg";